import { render, staticRenderFns } from "./EventStateNoDateWarning.vue?vue&type=template&id=6c4b95de&"
import script from "./EventStateNoDateWarning.vue?vue&type=script&lang=js&"
export * from "./EventStateNoDateWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports